import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DegreeQuizState, _STATE_DEGREE_QUIZ_FEATURE_KEY } from './degree-quiz.reducer';
import { DegreeQuizOption, DegreeQuizSlug } from '../../models/degree-quiz.models';

export const degreeQuizStateSelector = createFeatureSelector<DegreeQuizState>(
	_STATE_DEGREE_QUIZ_FEATURE_KEY,
);

export const getDegreeQuizStateQuizOptions = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.quizOptions,
);

export const getDegreeQuizStateQuizQuestions = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.quizQuestions,
);

export const getDegreeQuizStateSubjectGuides = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.guides,
);

export const getDegreeQuizAnswers = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.quizAnswers,
);

export const getDegreeQuizSlug = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.quizSlug,
);

export const getDegreeQuizVersion = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.quizVersion,
);

export const getDegreeQuizSubmitted = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.quizSubmitted,
);

export const getDegreeQuizResult = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.quizResult,
);

export const getDegreeQuizSelectedId = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => getIdBySlug(state.quizSlug, state.quizOptions),
);

export const getDegreeQuizResultId = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.resultId,
);

export const getDegreeQuizError = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.error,
);

export const getDegreeQuizIsLoading = createSelector(
	degreeQuizStateSelector,
	(state: DegreeQuizState) => state.isLoading,
);

const getIdBySlug = (slug: DegreeQuizSlug | null, options: DegreeQuizOption[]) => {
	if (!slug) return '';
	const id = options.filter((option) => option.slug === slug)[0].id;
	return id;
};
